import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

import { APP_TZ, formatNumber } from "../../lib/format";

dayjs.extend(utc);
dayjs.extend(timezone);

// 유입 분석 화면의 기간 전환(?range=) — 이번 달 · 최근 3개월(이번 달 포함 석 달) · 올해 · 최근 12개월(이번 달 포함 열두 달).
export const INSIGHT_RANGES = ["month", "3m", "year", "12m"] as const;
export type InsightRange = (typeof INSIGHT_RANGES)[number];
export const DEFAULT_INSIGHT_RANGE: InsightRange = "3m";

export const INSIGHT_RANGE_LABEL: Record<InsightRange, string> = {
  month: "이번 달",
  "3m": "최근 3개월",
  year: "올해",
  "12m": "최근 12개월",
};

export const parseInsightRange = (value: unknown): InsightRange =>
  (INSIGHT_RANGES as readonly unknown[]).includes(value) ? (value as InsightRange) : DEFAULT_INSIGHT_RANGE;

export const insightRangeHref = (range: InsightRange): string =>
  range === DEFAULT_INSIGHT_RANGE ? "/app/insights" : `/app/insights?range=${range}`;

// 코호트 시작 — KST 기준 이번 달 1일 · 두 달 전 1일 · 1월 1일 · 열한 달 전 1일, 모두 0시.
export const rangeStart = (range: InsightRange, now: Date | string): dayjs.Dayjs => {
  const today = dayjs(now).tz(APP_TZ);
  if (range === "year") return today.startOf("year");
  if (range === "3m") return today.subtract(2, "month").startOf("month");
  if (range === "12m") return today.subtract(11, "month").startOf("month");
  return today.startOf("month");
};

// 기간 안의 달(YYYY-MM, KST) — 시작 달부터 이번 달까지.
export const rangeMonths = (range: InsightRange, now: Date | string): string[] => {
  const end = dayjs(now).tz(APP_TZ).format("YYYY-MM");
  const months: string[] = [];
  let cursor = rangeStart(range, now);
  while (months.length < 12) {
    const key = cursor.format("YYYY-MM");
    months.push(key);
    if (key === end) break;
    cursor = cursor.add(1, "month");
  }
  return months;
};

// 머리 한 줄 — 「07-01 ~ 09-30 · 문의 42건」 · 해를 넘기면 「2025-10-01 ~ 2026-09-30」 로 연도를 붙인다.
export const rangeCaption = (range: InsightRange, now: Date | string, inquiries: number): string => {
  const start = rangeStart(range, now);
  const end = dayjs(now).tz(APP_TZ);
  const fmt = start.year() === end.year() ? "MM-DD" : "YYYY-MM-DD";
  return `${start.format(fmt)} ~ ${end.format(fmt)} · 문의 ${formatNumber(inquiries)}건`;
};
